import styled from 'styled-components';
import { colors } from 'Constants/Colors';
import { color, fontStyle } from '@mui/system';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-basis: shrink;
  box-sizing: border-box;
  position: relative;
`;

export const Header = styled.div`
  padding: 2rem 0 0 2rem;
  display: flex;
  flex-direction: row;
  height: 20%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 3rem;
`;

export const Body = styled.div`
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  height: 50%;
  font-family: quicksand;
  margin-bottom: 4rem;
`;

export const ButtonContainer = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 10%;
  gap: 1rem;
`;

export const FloatingClose = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: ${colors.GRAY_DARK};
  cursor: pointer;
`;

export const IconContainer = styled.div`
  background: ${colors.GREEN_ULTRA_LIGHT};
  border-radius: 1rem;
  padding: 0.5rem 0.75rem;
`;

export const inputStyle = {
  width: '100%',
  fontFamily: 'quicksand',
};

export const acceptButton = {
  width: '30%',
  height: '100%',
  borderRadius: '0.5rem',
  background: colors.GREEN_LEAF,
};

export const cancelButton = {
  border: `0.15rem solid ${colors.GREEN_LEAF}`,
  width: '30%',
  height: '100%',
  borderRadius: '0.5rem',
  color: colors.GREEN_LEAF,
};

export const titleStyle = {
  fontSize: '1.25rem',
  fontWeight: 'bold',
  fontFamily: 'metropolis',
  marginBottom: '0.25rem',
};

export const iconStyle = {
  color: colors.GREEN_SHINING,
};

export const hrStyle = {
  // margin: '0',
  // border: '0',
  padding: '0',
  margin: '0',
  borderTop: '1px solid #c9c7c7',
  width: '100%',
};

export default {
  ModalContainer,
  Header,
  Body,
  ButtonContainer,
  inputStyle,
  FloatingClose,
  acceptButton,
  cancelButton,
  titleStyle,
  iconStyle,
  IconContainer,
  hrStyle,
};
